import { Box, Button } from '@mui/material'

const styles = {
  footer: (theme) => ({
    padding: '0px',
    zIndex: 1201,
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '50px',
    backgroundColor: '#1a1a1a',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    '& ul': {
      // marginBottom: '20px',
      listStyle: 'none',
      padding: 0,
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    '& li': {
      display: 'inline-block',
      // margin: '0 5px',
      borderRight: '1px solid #fff',
      paddingRight: '10px',
      paddingLeft: '10px',
      fontSize: '0.78125rem',
      '&:last-child': { borderRight: 'none' },
      [theme.breakpoints.down('sm')]: {
        borderRight: 'none',
      },
    },
    '& a': {
      color: '#fff',
      textTransform: 'none',
      padding: 0,
      fontWeight: 'normal',
    },
  }),
  button: {
    minWidth: 'auto',
  },
}

export const footerLinksStyles = {
  container: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '20px',
    lineHeight: 1.6,
  },
  heading: {
    marginTop: '30px',
    marginBottom: '15px',
    fontWeight: 'bold',
  },
  subheading: {
    marginTop: '25px',
    marginBottom: '12px',
    fontWeight: 'bold',
  },
  paragraph: {
    marginBottom: '15px',
  },
  contactInfo: {
    backgroundColor: '#f5f5f5',
    padding: '20px',
    borderRadius: '8px',
    margin: '20px 0',
  },
  effectiveDate: {
    fontStyle: 'italic',
    marginBottom: '20px',
  },
}

const Footer = () => {
  return (
    <Box sx={styles.footer} id="alabala">
      <ul>
        <li>
          <Button href="/about" sx={styles.button}>
            About
          </Button>
        </li>
        <li>
          <Button href="/editorial-policy" sx={styles.button}>
            Editorial Policy
          </Button>
        </li>
        <li>
          <Button href="/terms" sx={styles.button}>
            Terms of Use
          </Button>
        </li>
        <li>
          <Button href="/privacy" sx={styles.button}>
            Privacy Policy
          </Button>
        </li>
        <li>
          <Button href="/contact" sx={styles.button}>
            Contact
          </Button>
        </li>
      </ul>
    </Box>
  )
}

export default Footer
